<p-dialog #dialog appendTo="body" header="Update Port Alias" [(visible)]="visible" [modal]="true"
		  [resizable]="false" styleClass="single-port-status-dialog"
		  [style]="{'width': '600px', 'height': '330px'}" (onHide)="onHide()">

	<single-port-alias-editor [deviceGuid]="deviceGuid" [ifIndex]="ifIndex" [visible]="visible">
	</single-port-alias-editor>

	<p-footer>
		<button type="button" pButton icon="fa fa-times" [disabled]="false"
				(click)="onCloseClicked()" label="Close"></button>
	</p-footer>

</p-dialog>
